<template>
  <div class="container-fluid">
    <!-- <div class="invoice-section" ref="invoiceSection" v-html="receiptData"></div> -->
    <!-- <b-modal
      centered
      ref="invoiceModal"
      hide-footer
      ok-disabled
      no-close-on-backdrop
      class="modal-dialog modal-content"
      role="document"
    >
      <div slot="modal-header" style="text-align: center !important;">
        <b-btn
          class="close custom-modal__close"
          style="justify-content: center !important; font-size: .89em;"
          @click="hideModal"
        >
          <span aria-hidden="true" class="fa fa-close"></span>
        </b-btn>
        <img src="/static/img/modal/7.png" alt class />
        <h2 class="page-content__header-description">Create Invoice</h2>
      </div>
      <div class="d-block text-center">
        <b-form-input type="text" placeholder="Invoice Input" v-model="componentName"></b-form-input>
        <b-button size="md" variant="primary" style="margin-top: 12px;">
          Send Invoice &nbsp;
          <span class="fa fa-plus"></span>
        </b-button>
      </div>
    </b-modal>-->
    <!--  -->
    <transition :css="false">
    <el-dialog title="Are you sure" :visible.sync="centerDialogVisible" width="30%" center>
      <span>Do you want to delete this request?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">No</el-button>
        <el-button type="primary" @click="deleteRequest(selectedRequest.id)">Yes</el-button>
      </span>
    </el-dialog>
    </transition>
    <vk-offcanvas overlay flipped stuck :show.sync="showInvoice">
      <!-- {{packageConfigs}} -->
      <div>
        <vk-offcanvas-close @click="showInvoice = false"></vk-offcanvas-close>
        <!-- <h3>New Customer</h3> -->
        <hr />
        <svg
          class="wow-star"
          version="1.1"
          viewBox="0 0 300 300"
          preserveAspectRatio="xMinYMin meet"
        >
          <foreignobject class="wow-star__text" width="100%" height="100%" v-html="receiptData" />
        </svg>
        <!-- <div class="invoice-section" v-html="receiptData"></div> -->
        <!-- {{systemTypes}} -->
      </div>
    </vk-offcanvas>

    <div class="main-container request-table-height">
      <div style="width: 100%;">
        <el-input
          style="max-width: 200px"
          placeholder="Type something"
          prefix-icon="el-icon-search"
          v-model="searchTerm"
        ></el-input>
        <vue-good-table
          :lineNumbers="true"
          :columns="columns"
          :rows="deviceRequests"
          :search-options="{enabled: true,
            searchFn: searchTable,
            externalQuery: searchTerm}"
          :pagination-options="{enabled: true}"
        >
          <template slot="table-row" slot-scope="props">
            <!-- {{props.row}} -->
            <span
              v-if="props.column.field == 'full_name'"
            >{{ props.row.user? `${props.row.user['firstName'] } ${ props.row.user['lastName']}`:'--' }}</span>
            <span
              v-if="props.column.field == 'installation_name'"
            >{{props.row['installationName'] ? `${props.row['installationName'] } ` : `${props.row.user['firstName'] } ${ props.row.user['lastName']}` }}</span>
            <span
              v-if="props.column.field == 'email'"
            >{{ props.row.user? `${props.row.user['email'] } ` :'--' }}</span>
            <span
              v-if="props.column.field == 'user.phone'"
            >{{ props.row.user? `${props.row.user['phoneNumber'] } ` :'--' }}</span>
            <span
              v-if="props.column.field == 'deviceType.name'"
            >{{ props.row.deviceType? `${props.row.deviceType['name']} ` :'--' }}</span>
            <span
              v-if="props.column.field == 'system.capacity'"
            >{{ props.row.systemCapacity? `${props.row.systemCapacity}kVA` :'--' }}</span>
            <!-- <span v-if="props.column.field == 'address'">
             @click="deleteRequest(props.row.id)"
             {{   props.row.deviceType? props.row    :'--' }} 
            </span>-->
            <span v-else>{{props.row[props.column.field]}}</span>
            <span v-if="props.column.field == 'actions'">
              <b-button-group>
                <can I="manage" a="installation">
                  <router-link :to="`/device-request/${props.row['id']}`">
                    <b-button variant="primary" v-show="props.row.status == 0">
                      View Status &nbsp;
                      <span class="fa fa-check"></span>
                    </b-button>
                  </router-link>
                </can>

                <can I="update" a="installation">
                  <router-link :to="`/device-request/${props.row['id']}`">
                    <b-button size="md" variant="info" v-show="props.row.status == 1">
                      Approve Installation &nbsp;
                      <span class="fa fa-calendar"></span>
                    </b-button>
                  </router-link>
                </can>

                <can I="create" a="invoice">
                  <!-- <b-button
                    variant="danger"
                    v-show="props.row.status == 0"
                    @click="fetchInvoice(props.row.id)"
                  >
                    View Invoice &nbsp;
                    <span class="fa fa-file-text"></span>
                  </b-button>-->
                </can>&nbsp;
                <can I="delete" a="installation">
                  <b-button
                    class="delete-btn"
                    variant="danger"
                    size="md"
                    @click="selectedRequest = props.row; centerDialogVisible = true"
                  >
                    Delete Request &nbsp;
                    <span class="fa fa-trash"></span>
                  </b-button>&nbsp;
                </can>
              </b-button-group>
              <!-- <b-button
                variant="danger"
                v-show="props.row.status == 0"
                @click="fetchInvoice(props.row.id)"
              >
                View Invoice &nbsp;
                <span class="fa fa-file-text"></span>
              </b-button>-->
            </span>
          </template>
          <template slot="pagination-bottom" slot-scope="props">
            <grey-pagination
              :total="props.total"
              :pageChanged="props.pageChanged"
              :perPageChanged="props.perPageChanged"
            ></grey-pagination>
          </template>
        </vue-good-table>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
// import ejs from "ejs";
import { mapGetters, mapActions } from "vuex";
import { readString } from "fs-web";
import templateLocation from "raw-loader!./templates/invoice.ejs";
import { Offcanvas, OffcanvasClose } from "vuikit/lib/offcanvas";
import { Dialog } from "element-ui";
const dataParam = {
  packageConfig: null,
  order: {
    paymentModel: "OS",
    orderVat: 5,
    orderDiscount: 0,
    typeOfBuilding: "Normal",
    roofType: "Aluminium",
    roofCondition: "Very Good",
    roofReadiness: "Very Ready",
    roofAge: 4,
    roofComment: "No comment here\tRoof is ready for installation",
    deviceTypeId: 3,
    comment: "No comment here\tRoof is ready for installation"
  },
  user: {
    firstName: "Test",
    email: "seun.omotunde@arnergy.com",
    roleType: "customer",
    lastName: "Testerson",
    dateOfBirth: "2019-07-10T17:22:47.521Z",
    phoneNumber: "234671993331",
    gender: 0,
    wallet: 0,
    createdAt: "2019-07-10T17:55:56.668Z",
    updatedAt: "2019-07-10T17:55:56.668Z",
    realm: "",
    username: "seun.omotunde@arnergy.com",
    emailVerified: null,
    id: 615,
    street_route: null,
    cpassword: "<%DUMMY%>",
    stateId: null,
    countryId: 1,
    lgaId: null,
    deviceRequest: {
      paymentModel: "OS",
      orderVat: 7.5,
      orderDiscount: 0,
      typeOfBuilding: "Normal",
      roofType: "Aluminium",
      roofCondition: "Very Good",
      roofReadiness: "Very Ready",
      roofAge: 4,
      roofComment: "No comment here\tRoof is ready for installation",
      deviceTypeId: 3,
      comment: "No comment here\tRoof is ready for installation"
    }
  },
  packageType: {
    name: "ARNERGY5000",
    description: "Arnergy5000 are the pet version for SME",
    price: 4004485,
    OTAEnabled: true,
    chainable: true,
    createdAt: "2018-06-21T20:20:25.000Z",
    updatedAt: "2018-06-21T20:20:25.000Z",
    id: 3,
    packageComponents: [
      {
        quantity: 1,
        createdAt: "2019-07-02T12:28:34.267Z",
        updatedAt: "2019-07-02T12:28:34.267Z",
        id: 12,
        deviceTypeId: 3,
        componentId: 2,
        componentTypeId: null,
        componentType: {
          name: "inverter",
          description: null,
          createdAt: "2018-06-21T20:20:25.000Z",
          updatedAt: "2018-06-21T20:20:25.000Z",
          id: 2
        }
      },
      {
        quantity: 2,
        createdAt: "2019-07-02T12:28:47.102Z",
        updatedAt: "2019-07-02T12:28:47.102Z",
        id: 13,
        deviceTypeId: 3,
        componentId: 1,
        componentTypeId: null,
        componentType: {
          name: "battery",
          description: null,
          createdAt: "2018-06-21T20:20:25.000Z",
          updatedAt: "2018-06-21T20:20:25.000Z",
          id: 1
        }
      },
      {
        quantity: 15,
        createdAt: "2019-07-02T14:16:33.398Z",
        updatedAt: "2019-07-02T14:16:33.398Z",
        id: 16,
        deviceTypeId: 3,
        componentId: 3,
        componentTypeId: null,
        componentType: {
          name: "solar panels",
          description: null,
          createdAt: "2018-06-21T20:20:25.000Z",
          updatedAt: "2018-06-21T20:20:25.000Z",
          id: 3
        }
      }
    ]
  },
  selectedRequest: null
};
export default {
  name: "manage-requests",
  data() {
    return {
      receiptData: "Loading...",
      centerDialogVisible: false,
      showInvoice: false,
      searchTerm: "",
      selectOption: {
        enabled: true
      },
      responseData: "",
      errors: "",
      componentName: "",
      columns: [
        {
          label: "Customer Name",
          field: "full_name"
        },
        {
          label: "Installation Name",
          field: "installation_name",
          filterable: true
        },
        {
          label: "Phone Number",
          field: "user.phone",
          filterable: true
        },
        // {
        //   label: 'Installation Address',
        //   field: 'address',
        //   filterable: true,
        // },
        {
          label: "Desired Bundle",
          field: "deviceType.name",
          filterable: true
        },
        {
          label: "System Capacity",
          field: "system.capacity",
          filterable: true
        },
        {
          label: "Actions",
          field: "actions"
        }
      ],
      deviceRequests: [],
      rows: []
    };
  },
  components: {
    "vk-offcanvas": Offcanvas,
    "vk-offcanvas-close": OffcanvasClose,
    "el-dialog": Dialog
  },
  methods: {
    random_num: dumm => {
      return Math.floor(Math.random(9999) * 9999);
    },
    showModal() {
      this.$refs.invoiceModal.show();
    },
    hideModal() {
      this.$refs.invoiceModal.hide();
    },
    navTo(id) {
      this.$router.push({
        name: "addInstalation",
        params: {
          id: id
        }
      });
    },
    async fetchInvoice(rowData) {
      // console.log({ rowData, templateLocation });
      this.showInvoice = true;
      let { order, user, packageConfig, packageType } = dataParam;
      // readString(templateLocation).then(console.log);
      let html = ejs.render(templateLocation, {
        order,
        user,
        packageConfig,
        packageType,
        setupURL: false
      });
      const el = this.$refs.invoiceSection;
      const options = {
        type: "dataURL"
      };
      this.receiptData = html;
      // this.finalData = await this.$html2canvas(el, options);
      // console.log({ finalData });
    },
    searchTable(row, col, cellValue, searchTerm) {
      return (
        Object.values(row)
          .join("<%>")
          .toLowerCase()
          .indexOf(searchTerm.toLowerCase()) > -1
      );
    },
    deleteRequest(id) {
      const HTTP = this.$httpUtils.instance;
      // console.log(id);
      HTTP.delete(`/device_requests/${id}`)
        .then(response => {
          this.centerDialogVisible = false;
          window.location.reload(true);
        })
        .catch(e => {
          console.log(e);
        });
    }
  },
  computed: {},
  mounted() {
    if (!this.$can("create", "installation")) {
      this.$router.push({
        path: "/"
      });
      return;
    }
    const HTTP = this.$httpUtils.instance;
    const container = this;

    // {"status": 1}
    HTTP.get(
      `/device_requests/?filter={"include": ["user","transactionHistories", {"deviceType": { "packageComponents": "componentType" }}], 
      "where": {
        "or":[
          {"status": 0},
          {"status": 1}
        ]
        } }`,
      {}
    ).then(response => {
      // console.log(JSON.stringify(rolesdata.data))
      console.log({ response });

      container.deviceRequests = response.data.filter(x => x.user);
    });
  }
};
</script>

<style>
.widget_box {
  min-height: auto !important;
}

.modal-header {
  border-bottom-left-radius: 50% 20%;
  border-bottom-right-radius: 50% 20%;
  background: #ecf2f6;
  /* height: 100px; */
}

.request-table-height {
  height: calc(100vh - 280px);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/devices/ManageRequests.vue